import { t } from '@lingui/core/macro';
import { useSearchContext } from '../../../SearchProvider';
export function useUsers(userIds) {
    const { values } = useSearchContext();
    const { users } = values;
    const fallbackUser = {
        id: '',
        name: t({ message: 'Deleted user', comment: 'Fallback name for deleted user' }),
    };
    const userData = userIds.map((uid) => users.get(uid) || fallbackUser);
    return userData;
}
